import React from "react";
import styled from "styled-components";
import { Check, Circle, Clock } from "react-feather";
import { rawColors } from "../design-system/tokens/colors";

export interface Step {
  id: string;
  label: string;
  state: "pending" | "active" | "completed" | "error";
  description?: string;
}

interface StepperProps {
  steps: Step[];
  className?: string;
}

const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  //   padding: 16px 24px;
  //   background: rgba(255, 255, 255, 0.95);
  //   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  //   backdrop-filter: blur(8px);
  width: 100%;
  //max-width: 1200px;
  margin: 0 auto;
`;

const StepperTrack = styled.div`
  display: flex;
  align-items: center;
  //   gap: 8px;
  flex: 1;
  //max-width: 800px;
`;

const StepItem = styled.div<{ $state: Step["state"] }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: ${({ $state }) => ($state === "active" ? "2px 4px" : "0px")};
  border-radius: 18px;
  transition: all 0.3s ease;
  background: ${({ $state }) => {
    switch ($state) {
      case "completed":
        return "rgba(34, 197, 94, 0.1)";
      case "active":
        return "#fff";
      case "error":
        return "rgba(239, 68, 68, 0.1)";
      default:
        return "rgba(156, 163, 175, 0.1)";
    }
  }};
  border: 1px solid
    ${({ $state }) => {
      switch ($state) {
        case "completed":
          return "transparent"; // "rgba(34, 197, 94, 0.3)";
        case "active":
          return "transparent"; //"rgba(59, 130, 246, 0.3)";
        case "error":
          return "transparent"; //"rgba(239, 68, 68, 0.3)";
        default:
          return "transparent"; //"rgba(156, 163, 175, 0.3)";
      }
    }};

  &:first-child {
    position: absolute;
    left: 10px;
  }

  &:last-child {
    position: absolute;
    right: 10px;
  }
`;

const StepIcon = styled.div<{ $state: Step["state"] }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $state }) => {
    switch ($state) {
      case "completed":
        return "#2E9A79";
      case "active":
        return "#3A73DF";
      case "error":
        return "#ef4444";
      default:
        return "#3A73DF";
    }
  }};
  color: white;
  font-size: 12px;
  font-weight: 600;
`;

const StepLabel = styled.span<{ $state: Step["state"] }>`
  font-size: 12px;
  font-weight: 500;
  color: ${({ $state }) => {
    switch ($state) {
      case "completed":
        return "#16a34a";
      case "active":
        return rawColors.text.mediumEmphasis;
      case "error":
        return "#dc2626";
      default:
        return rawColors.text.mediumEmphasis;
    }
  }};
`;

const StepConnector = styled.div<{ $isCompleted: boolean }>`
  height: 4px;
  flex: 1;
  min-width: 24px;
  background: ${({ $isCompleted }) => ($isCompleted ? "#3A73DF" : "#DEDCE5")};
  transition: background 0.3s ease;
`;

const getStepIcon = (state: Step["state"]) => {
  switch (state) {
    case "completed":
      return <Check size={12} />;
    case "active":
      return <Check size={12} />;
    case "error":
      return "!";
    default:
      return <></>;
  }
};

const Stepper: React.FC<StepperProps> = ({ steps, className }) => {
  return (
    <StepperContainer className={className}>
      <StepperTrack>
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <StepItem $state={step.state}>
              <StepIcon $state={step.state}>{getStepIcon(step.state)}</StepIcon>
              {step.state === "active" ? (
                <StepLabel $state={step.state}>{step.label}</StepLabel>
              ) : (
                <></>
              )}
            </StepItem>
            {index < steps.length - 1 && (
              <StepConnector $isCompleted={step.state === "completed"} />
            )}
          </React.Fragment>
        ))}
      </StepperTrack>
    </StepperContainer>
  );
};

export default Stepper;
